var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
export var cart = {
    updating: function (ctx, delay, customMessage) {
        if (customMessage === void 0) { customMessage = null; }
        if (ctx) {
            var container = document.createElement("div");
            container.id = "_updating";
            container.classList.add("position-fixed", "min-vh-100", "min-vw-100", "bg-black-opacity-0_5", "d-flex", "flex-column", "justify-content-center");
            container.style.zIndex = "9999";
            var card = document.createElement("div");
            card.classList.add("card", "rounded", "align-self-center");
            var cardBody = document.createElement("div");
            cardBody.classList.add("card-body", "d-flex", "flex-row");
            cardBody.style.width = "18rem";
            var cardTitle = document.createElement("div");
            cardTitle.classList.add("align-self-center", "mr-auto", "font-weight-bold");
            cardTitle.innerText = customMessage ? customMessage : "Updating...";
            var cardSpinner = document.createElement("div");
            cardSpinner.classList.add("spinner-border");
            cardBody.appendChild(cardTitle);
            cardBody.appendChild(cardSpinner);
            card.appendChild(cardBody);
            container.appendChild(card);
            document.body.prepend(container);
        }
        else {
            var toast_1 = document.getElementById("_updating");
            setTimeout(function () {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                toast_1.remove();
            }, delay);
        }
    },
    toast: function (success, message) {
        var toast = document.createElement("div");
        toast.classList.add("toast", "ml-auto", "rounded-0", "show");
        toast.style.width = "300px";
        var toastHeader = document.createElement("div");
        toastHeader.classList.add("toast-header");
        var toastButton = document.createElement("button");
        toastButton.classList.add("ml-auto", "mb-1", "close", "text-white");
        toastButton.dataset.dismiss = "toast";
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        var toastBody = document.createElement("div");
        toastBody.classList.add("toast-body");
        if (success) {
            toastHeader.classList.add("bg-success");
        }
        else {
            toastHeader.classList.add("bg-danger");
        }
        toastBody.innerText = message;
        toastHeader.appendChild(toastButton);
        toast.appendChild(toastHeader);
        toast.appendChild(toastBody);
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        document.getElementById("toastPlaceHolder").append(toast);
        setTimeout(function () {
            toast.remove();
        }, 5000);
    },
    fetchCart: function (uri, data, method) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetch(uri, {
                            method: method,
                            mode: "cors",
                            redirect: "follow",
                            cache: "no-cache",
                            credentials: "same-origin",
                            headers: {
                                Accept: "application/json",
                            },
                            body: data,
                        })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.json()];
                }
            });
        });
    },
    formatCurrency: function (value) {
        var parts = value.toString().split(".");
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return parts.join(".");
    },
};
